// extracted by mini-css-extract-plugin
export default {"compactAll":"add_compactAll__Pl83-","compactMobile":"add_compactMobile__CfhLZ"};